module.exports = __webpack_public_path__ + "static/img/13.49ee8309.png";